module.exports = __webpack_public_path__ + "static/media/add_object.9f46997c.png";